<template>
    <div v-if="visible" class="notification-bell">
        <v-menu v-model="opened" offset-y left :close-on-content-click="false" content-class="notification-menu" :max-width="480" max-height="80vh">
            <template #activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" :aria-label="label" :class="{ 'notification-bell--new': inbox.unread_count > 0 }" title="Notifiche">
                    <v-badge :value="badge !== ''" :content="badge" overlap>
                        <v-icon>{{ inbox.error || inbox.stale ? 'mdi-bell-alert-outline' : 'mdi-bell-outline' }}</v-icon>
                    </v-badge>
                </v-btn>
            </template>
            <notification-panel v-if="opened" @close="opened = false" />
        </v-menu>
    </div>
</template>
<script>
import NotificationPanel from "./NotificationPanel.vue";
import { observeNotifications } from "./notificationConnection";
import { number } from "../../assets/mecom/js/format.mjs";
import "./notifications.css";
export default {
    name: "NotificationBell",
    components: { NotificationPanel },
    data: () => ({ opened: false }),
    computed: {
        inbox() { return this.$store.state.notifications; },
        visible() {
            return Boolean(this.inbox.error) || this.inbox.open_count > 0 || (this.inbox.applicable &&
                (this.inbox.stale || this.inbox.open_count === null));
        },
        badge() {
            if (this.inbox.error || (this.inbox.stale && this.inbox.open_count === null)) return "!";
            return this.inbox.open_count > 99 ? "99+" : this.inbox.open_count > 0 ? number(this.inbox.open_count, 0) : "";
        },
        label() { return `Notifiche: ${this.inbox.error || this.inbox.stale || this.inbox.open_count === null ? 'disponibilità da verificare' : `${number(this.inbox.open_count, 0)} ${this.inbox.open_count === 1 ? 'gruppo di attività aperto' : 'gruppi di attività aperti'}`}, ${number(this.inbox.unread_count, 0)} ${this.inbox.unread_count === 1 ? 'nuova' : 'nuove'}`; },
    },
    watch: { visible(value) { if (!value) this.opened = false; } },
    mounted() {
        // Keep observing even when the rendered bell is hidden: new work must reveal it.
        // eslint-disable-next-line no-undef
        this.stopObserver = observeNotifications({ store: this.$store, work: this.$work, socketBase: this.$workWs, disabled: process.env.VUE_APP_DISABLE_SOCKET === "true" });
    },
    beforeDestroy() { this.stopObserver?.(); },
};
</script>
